import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatPanelWrapper = createCustomElementWrapper('kat-panel-wrapper', 'KatPanelWrapper', {
    'maskBackground': 'mask-background',
    'panelVisible': 'panel-visible',
}, {}, [
    'panel',
]);
